import { Properties } from "@/services/posts/types";
import { CSS } from "@/services/styles/types";

export interface DatePostProperties extends Properties {
    language: string;
    format: string;
    dateFormat: MomentFormat;
    showTime: number;
    timeZone:string
}

export interface Format {
    text: string;
    value: FormatValue;
}

export interface FormatValue {
    format: string;
    capitalize: CapitalizeEnum
}

export interface DateStyle extends CSS {
    date: string;
}

export enum CapitalizeEnum {
    FirtLetterCapital = "FirstLetterCapital",
    LowerCase = "LowerCase",
    Locale = "Locale"
}

export interface MomentFormat {
    textOne: string;
    textTwo: string;
    textThree: string;
    textFour: string;
    textFive: string;
    dateOptionOne: FormatValue;
    dateOptionTwo: FormatValue;
    dateOptionThree: FormatValue;
    dateOptionFour: FormatValue;
}

export const FormatOptions = [
    {
        text: "none",
        value: {
            format: "",
            capitalize: CapitalizeEnum.Locale
        }
    },
    {
        text: "d",
        value: {
            format: "D",
            capitalize: CapitalizeEnum.Locale
        }
    },
    {
        text: "dd",
        value: {
            format: "DD",
            capitalize: CapitalizeEnum.Locale
        }
    },
    {
        text: "m",
        value: {
            format: "M",
            capitalize: CapitalizeEnum.Locale
        }
    },
    {
        text: "mm",
        value: {
            format: "MM",
            capitalize: CapitalizeEnum.Locale
        }
    },
    {
        text: "yy",
        value: {
            format: "YY",
            capitalize: CapitalizeEnum.Locale
        }
    },
    {
        text: "yyyy",
        value: {
            format: "YYYY",
            capitalize: CapitalizeEnum.Locale
        }
    },
    {
        text: "month",
        value: {
            format: "MMMM",
            capitalize: CapitalizeEnum.LowerCase
        }
    },
    {
        text: "Month",
        value: {
            format: "MMMM",
            capitalize: CapitalizeEnum.FirtLetterCapital
        }
    },
    {
        text: "month short",
        value: {
            format: "MMM",
            capitalize: CapitalizeEnum.LowerCase
        }
    },
    {
        text: "Month short",
        value: {
            format: "MMM",
            capitalize: CapitalizeEnum.FirtLetterCapital
        }
    },
    {
        text: "day",
        value: {
            format: "dddd",
            capitalize: CapitalizeEnum.LowerCase
        }
    },
    {
        text: "Day",
        value: {
            format: "dddd",
            capitalize: CapitalizeEnum.FirtLetterCapital
        }
    },
    {
        text: "day short",
        value: {
            format: "ddd",
            capitalize: CapitalizeEnum.LowerCase
        }
    },
    {
        text: "Day short",
        value: {
            format: "ddd",
            capitalize: CapitalizeEnum.FirtLetterCapital
        }
    }
] as Array<Format>;

// languages
export const Languages =
[
    {
        text: "Afrikaans",
        code: "af"
    },
    {
        text: "Albanian",
        code: "sq"
    },
    {
        text: "Arabic",
        code: "ar"
    },
    {
        text: "Armenian",
        code: "hy-am"
    },
    {
        text: "Azerbaijani",
        code: "az"
    },
    {
        text: "Bahasa Indonesia",
        code: "id"
    },
    {
        text: "Bahasa Malaysia",
        code: "ms-my"
    },
    {
        text: "Belarusian",
        code: "be"
    },
    {
        text: "Bengali",
        code: "bn"
    },
    {
        text: "Bosnian",
        code: "bs"
    },
    {
        text: "Bulgarian",
        code: "bg"
    },
    {
        text: "Burmese",
        code: "my"
    },
    {
        text: "Catalan",
        code: "ca"
    },
    {
        text: "Chinese (China)",
        code: "zh-cn"
    },
    {
        text: "Chinese (Hong Kong)",
        code: "zh-hk"
    },
    {
        text: "Chinese (Taiwan)",
        code: "zh-tw"
    },
    {
        text: "Croatian",
        code: "hr"
    },
    {
        text: "Czech",
        code: "cs"
    },
    {
        text: "Danish",
        code: "da"
    },
    {
        text: "Dutch",
        code: "nl"
    },
    {
        text: "English (Australia)",
        code: "en-au"
    },
    {
        text: "English (Canada)",
        code: "en-ca"
    },
    {
        text: "English (India)",
        code: "en-in"
    },
    {
        text: "English (New Zealand)",
        code: "en-nz"
    },
    {
        text: "English (South Africa)",
        code: "en-za"
    },
    {
        text: "English (United Kingdom)",
        code: "en-gb"
    },
    {
        text: "English (United States)",
        code: "en"
    },
    {
        text: "Estonian",
        code: "et"
    },
    {
        text: "Faroese",
        code: "fo"
    },
    {
        text: "Finnish",
        code: "fi"
    },
    {
        text: "French",
        code: "fr"
    },
    {
        text: "French (Canada)",
        code: "fr-ca"
    },
    {
        text: "Ganda",
        code: "xog"
    },
    {
        text: "Georgian",
        code: "ka"
    },
    {
        text: "German",
        code: "de"
    },
    {
        text: "Greek",
        code: "el"
    },
    {
        text: "Greenland",
        code: "kl"
    },
    {
        text: "Gujarati",
        code: "gu"
    },
    {
        text: "Hebrew",
        code: "he"
    },
    {
        text: "Hindi",
        code: "hi"
    },
    {
        text: "Hungarian",
        code: "hu"
    },
    {
        text: "Icelandic",
        code: "is"
    },
    {
        text: "Italian",
        code: "it"
    },
    {
        text: "Japanese",
        code: "ja"
    },
    {
        text: "Kannada",
        code: "kn"
    },
    {
        text: "Kazakh",
        code: "kk"
    },
    {
        text: "Khmer",
        code: "km"
    },
    {
        text: "Korean",
        code: "ko"
    },
    {
        text: "Kyrgyz",
        code: "ky"
    },
    {
        text: "Latvian",
        code: "lv"
    },
    {
        text: "Lithuanian",
        code: "lt"
    },
    {
        text: "Macedonian",
        code: "mk"
    },
    {
        text: "Malayalam",
        code: "ml"
    },
    {
        text: "Marathi",
        code: "mr"
    },
    {
        text: "Mongolian",
        code: "mn"
    },
    {
        text: "Montenegrin",
        code: "sr-me"
    },
    {
        text: "Nepali",
        code: "ne"
    },
    {
        text: "Norwegian",
        code: "nb"
    },
    {
        text: "Oriya",
        code: "or"
    },
    {
        text: "Pashto",
        code: "ps"
    },
    {
        text: "Persian",
        code: "fa"
    },
    {
        text: "Polish",
        code: "pl"
    },
    {
        text: "Portuguese",
        code: "pt"
    },
    {
        text: "Portuguese (Brazil)",
        code: "pt-br"
    },
    {
        text: "Punjabi",
        code: "pa-in"
    },
    {
        text: "Romanian",
        code: "ro"
    },
    {
        text: "Russian",
        code: "ru"
    },
    {
        text: "Serbian",
        code: "sr"
    },
    {
        text: "Sinhala",
        code: "si"
    },
    {
        text: "Slovak",
        code: "sk"
    },
    {
        text: "Slovenian",
        code: "sl"
    },
    {
        text: "Somali",
        code: "so"
    },
    {
        text: "Spanish",
        code: "es"
    },
    {
        text: "Spanish (Mexico)",
        code: "es-mx"
    },
    {
        text: "Swahili",
        code: "sw"
    },
    {
        text: "Swedish",
        code: "sv"
    },
    {
        text: "Tajik",
        code: "tg"
    },
    {
        text: "Tamil",
        code: "ta"
    },
    {
        text: "Telugu",
        code: "te"
    },
    {
        text: "Thai",
        code: "th"
    },
    {
        text: "Turkish",
        code: "tr"
    },
    {
        text: "Turkmen",
        code: "tk"
    },
    {
        text: "Ukrainian",
        code: "uk"
    },
    {
        text: "Urdu",
        code: "ur"
    },
    {
        text: "Uzbek",
        code: "uz"
    },
    {
        text: "Vietnamese",
        code: "vi"
    },
    {
        text: "Xhosa",
        code: "xh"
    },
    {
        text: "Yiddish",
        code: "yi"
    },
    {
        text: "Yoruba",
        code: "yo"
    },
    {
        text: "Welsh",
        code: "cy"
    },
    {
        text: "Zulu",
        code: "zu"
    }
];

// date format
export const DateFormats = [
    {
        text: "custom",
        value: "custom"
    },
    {
        text: "englishBritish",
        value: "e-b"
    },
    {
        text: "englishUS",
        value: "e-us"
    },
    {
        text: "danish",
        value: "dk"
    },
    {
        text: "swedish",
        value: "swed"
    },
    {
        text: "norweigan",
        value: "nor"
    },
    {
        text: "german",
        value: "ger"
    },
    {
        text: "french",
        value: "fr"
    },
    {
        text: "spanish",
        value: "esp"
    },
    {
        text: "portuguese",
        value: "prt"
    },
    {
        text: "mexican",
        value: "mex"
    }

];
